// ZOE's social proof numbers, shown on the quiz welcome screen's ratings row.
// Update them here; nothing else hard-codes them.
export const SOCIAL_PROOF = {
  appRatingsCount: '33K+',
  appRating: 4.8,
  monthlyUsers: '3 million',
}
